import React from "react";

const HighlightRibbonTwo = () => {
  return (
    <>
      <section className="container-fluid container--ribbon__highlight">
        <div className="section-width card-wrapper">
          <div className="card card--highlight">
            <p className="numeral">95%+</p>
            <p className="card-text card-text-highlight">
              improvement in student performance
            </p>
          </div>
          <div className="card card--highlight">
            <p className="numeral">10/10</p>
            <p className="card-text card-text-highlight">
              satisfaction from happy parents
            </p>
          </div>
          <div className="card card--highlight">
            <p className="numeral">3x</p>
            <p className="card-text card-text-highlight">
              faster concept clarity with creative methods
            </p>
          </div>
        </div>
      </section>
    </>
  );
};
export default HighlightRibbonTwo;
